<template>
  <PainelLayout>
    <Breadcrumb :lista="[ { 'name':'Painel', 'link' : '/' }]" />

    <div class="row">
      <div class="col-6">
        <h1>Estoque</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/stock/new">
          <button class="btn btn-primary mt-3">Adicionar Item</button>
        </router-link>
      </div>
    </div>
    <hr/>
    
    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: 'Código' }, { label: 'Nome' }, {label: 'Quantidade'},{label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.code},
          {value: item.name},
          {value: item.quant}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/stock/details', query: { id: item.id } }">
          <i class="bi bi-eye-fill"></i> Detalhes
        </router-link>
      </template>
      </app-trow>
    </app-table>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { itens } from '@/models/itens';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "StockView",
  components: {
    PainelLayout,
    Breadcrumb, AppTable, AppTrow
  },
  setup(props) {

    const toastStore = useToastStore();
    const lista = ref([]);
    const model = itens();
    const loading = ref(false);

    const { isAdmin, isUser, isOpeto } = usePermissions();

    var advancedMode = ref(false);
    const itemobj = reactive({
      id: null,
      name: ''
    });

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list();
      } catch (error) {
        toastStore.addToast('Erro ao listar itens', 'danger');
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      list();
    });

    return {
      lista,
      itemobj,
      isAdmin,
      isUser,
      isOpeto,
      loading,
    }
  }
}
</script>